module.exports = __webpack_public_path__ + "img/Momentum_720p-Camera.2_Pairing-Mode.9adcb9db.png";